<template>
    <div>
        <PageSpinner :onloader="onloader" />
        <base-header type="gradient-success" class="pb-6 pb-8 pt-5 pt-md-8">
            <router-link to="/dashboard" class="text-white">
                Dashboard
            </router-link>
            <router-link to="/school/attendance-management" class="text-white">
                <i class="fa fa-ellipsis-v px-2"></i>Attendance Management
            </router-link>
            <span class="text-white"><i class="fa fa-ellipsis-v px-2"></i>Student Attendance
            </span>
        </base-header>

        <!--Charts-->
        <div class="container-fluid mt--7">
            <card header-classes="bg-transparent">
                <div>
                    <div class="justify-content-end form-inline my-3">
                        <select v-model="ClassIdval" class="form-control" @change="getoptioninclassassigned()"
                            :disabled="!classitems">
                            <option value="0" v-if="!classitems">⏳ Loading...</option>
                            <option value="0" v-else>- Select Class -</option>
                            <option v-for="item in classitems" :key="item.Id" v-bind:value="item.Id">
                                {{ item.Sch_Class }}
                            </option>
                        </select>
                        <select v-model="OptionIdval" class="form-control" @change="getarminclassassigned()"
                            :disabled="!optionitems">
                            <option value="0" v-if="!optionitems">⏳ Loading...</option>
                            <option value="0" v-else>- Select Option -</option>
                            <option v-for="item in optionitems" :key="item.Id" v-bind:value="item.Id">
                                {{ item.ClassOption }}
                            </option>
                        </select>
                        <select v-model="ArmIdval" class="form-control" @change="GetLastStudentDailyAttendanceTaken()"
                            :disabled="!armitems">
                            <option value="0" v-if="!armitems">⏳ Loading...</option>
                            <option value="0" v-else>- Select Arm -</option>
                            <option v-for="item in armitems" :key="item.Id" v-bind:value="item.Id">
                                {{ item.SectionName }}
                            </option>
                        </select>
                        <base-input class="input-group-alternative" placeholder="Search here..."
                            addon-left-icon="fa fa-search" v-model="searchval">
                        </base-input>
                    </div>
                    <h2 class="text-center text-danger">{{ LastAttendanceDetails }}</h2>
                    <div v-if="ArmIdval">
                        <list-skeleton v-if="!students" :rows="3" />
                        <div v-else>
                            <div class="row">
                                <div class="col-lg-3" v-for="item in searchedResultQuery" :key="item.id">
                                    <div class="card text-center m-2 animate__animated animate__flipInX">
                                        <div class="card-body bg-success shrink">
                                            <img v-if="item.passport" :src="item.passport" class="rounded" alt=""
                                                height="50" />
                                            <img v-else src="/img/brand/loguser.png" class="rounded" alt=""
                                                height="50" />
                                            <h5 class="text-white"><small>{{ item.studentName }}</small> </h5>
                                            <h6 class="text-white"> <small>{{ item.admNo }} | {{ item.sch_Class }} | {{
                                                item.classOption }} |
                                                    {{
                                                        item.sectionName
                                                    }}</small> </h6>
                                            <div>
                                                <label class="cb cb-square">
                                                    <input type="checkbox" :value="item.studentId"
                                                        v-model="selectedItems">
                                                    <span class="cb-box" aria-hidden="true"><span
                                                            class="dot"></span></span>
                                                    <span class="text-white">Select if Present</span>
                                                </label>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="text-center card-footer mt-4" v-if="students">
                                <button @click="SubmitSelectedItems" class="btn btn-success">Submit Selected
                                    Items</button>
                            </div>
                        </div>
                    </div>
                </div>
            </card>
        </div>
    </div>
</template>

<script>
import Alert from "@/mixins/Alert.mixins"
import PageSpinner from "@/components/PageSpinner"
import CheckStaffUser from "@/mixins/CheckStaffUser.mixin"
export default {
    name: "student",
    components: {
        PageSpinner
    },
    mixins: [CheckStaffUser, Alert],
    data() {
        return {
            accessDetails: null,
            ClassIdval: 0,
            OptionIdval: 0,
            ArmIdval: 0,
            StudentIds: [],
            selectedItems: [],
            students: null,
            ImgPathval: "",
            LastAttendanceDetails: "",
            uploadedimage: "",
            searchval: "",
            IsSignIn: true,
            classitems: null,
            optionitems: null,
            armitems: null,
            onloader: "none",
            modals: {
                SignInModal: false
            }
        };
    },
    computed: {
        searchedResultQuery() {
            if (this.searchval) {
                return this.students.filter((item) => {
                    return this.searchval
                        .toLowerCase()
                        .split(" ")
                        .every(
                            (v) =>
                                item.studentName.toLowerCase().includes(v) ||
                                item.sch_Class.toLowerCase().includes(v) ||
                                item.admNo.toLowerCase().includes(v)
                        );
                });
            } else {
                return this.students;
            }
        },
    },
    methods: {
        SubmitSelectedItems() {
            let StudentIds = this.selectedItems;

            this.onloader = "flex";
            let userdata = {
                StudentIds
            }
            this.$store
                .dispatch("DailyRegister/CreatePortalDailyAttendance", userdata)
                .then((resp) => {
                    if (resp.responseCode == "00") {
                        this.GetLastStudentDailyAttendanceTaken();
                        this.onloader = "none";
                        this.ShowAlertSuccess('Submitted Successfully', '');
                    } else {
                        this.onloader = "none";
                        this.ShowAlertError(resp.responseMessage, '');
                    }

                })
                .catch((err) => {
                    this.onloader = "none";
                    this.ShowAlertError(err.response.data, '');
                });
        },
        GetStudentForDailyAttendance() {
            let SectionId = this.ArmIdval;
            if (SectionId > 0) {
                this.onloader = "flex";
                this.$store
                    .dispatch("PortalStudent/GetStudentForDailyAttendance", SectionId)
                    .then((resp) => {
                        this.students = resp.data;
                        this.onloader = "none";
                    })
                    .catch((err) => {
                        this.onloader = "none";
                        this.ShowAlertError(err.response.data, '');
                    });
            }

        },
        GetLastStudentDailyAttendanceTaken() {
            let SectionId = this.ArmIdval;
            if (SectionId > 0) {
                this.onloader = "flex";
                this.$store
                    .dispatch("DailyRegister/GetLastStudentDailyAttendanceTaken", SectionId)
                    .then((resp) => {
                        if (resp.responseCode == "00") {
                            if (resp.data != null) {
                                this.LastAttendanceDetails = `Last Attendance Taken, ${resp.data.portalDailyRegisterDetails} ${resp.data.dateCreated}`;
                            } else {
                                this.LastAttendanceDetails = `No Attendance Taken Yet`;
                            }
                            this.onloader = "none";
                        } else {
                            this.onloader = "none";
                        }
                        this.GetStudentForDailyAttendance();
                    })
                    .catch((err) => {
                        this.onloader = "none";
                        this.ShowAlertError(err.response.data, '');
                    });
            }

        },

        CloseSignIn() {
            this.modals.SignInModal = false
        },
        CloseSignOut() {
            this.modals.SignInModal = false
        },
        getclassinclassassigned() {
            this.classitems = null;
            this.students = null;
            this.optionitems = null;
            this.armitems = null;
            this.ClassIdval = 0;
            this.onloader = 'flex'
            this.$store.dispatch('getclassinclassassigned')
                .then(resp => {
                    this.classitems = resp;
                    this.onloader = 'none';
                })
                .catch(err => {
                    this.onloader = 'none'
                    this.ShowAlertError(err.response.data, '');
                })
        },
        getoptioninclassassigned() {
            this.optionitems = null;
            this.armitems = null;
            this.students = null;
            this.OptionIdval = 0;
            this.onloader = 'flex'
            let ClassId = this.ClassIdval;
            if (ClassId > 0) {
                this.$store.dispatch('getoptioninclassassigned', ClassId)
                    .then(resp => {
                        this.optionitems = resp;
                        this.onloader = 'none';
                    })
                    .catch(err => {
                        this.onloader = 'none'
                        this.ShowAlertError(err.response.data, '');
                    })
            }
        },
        getarminclassassigned() {
            this.students = null;
            this.armitems = null;
            this.ArmIdval = 0;
            this.onloader = 'flex'
            let OptionId = this.OptionIdval;
            if (OptionId > 0) {
                this.$store.dispatch('getarminclassassigned', OptionId)
                    .then(resp => {
                        this.armitems = resp;
                        this.onloader = 'none';
                    })
                    .catch(err => {
                        this.onloader = 'none'
                        this.ShowAlertError(err.response.data, '');
                    })
            }
        },
    },
    mounted() {
        this.getclassinclassassigned();
    },
};
</script>

<style>
:root {
    --cb-size: 22px;
    --accent: #ef4444;
    --bg: #fff;
    --border: #e5e7eb;
}

.cb-square {
    display: inline-flex;
    gap: .6rem;
    align-items: center;
    cursor: pointer;
}

.cb-square input {
    position: absolute;
    opacity: 0;
    pointer-events: none;
}

.cb-square .cb-box {
    width: var(--cb-size);
    height: var(--cb-size);
    display: inline-grid;
    place-items: center;
    background: var(--bg);
    border: 2px solid var(--border);
    border-radius: 6px;
    transition: transform .15s ease;
    position: relative;
    overflow: hidden;
}

.cb-square .dot {
    width: 0;
    height: 0;
    border-radius: 50%;
    background: var(--accent);
    transform: scale(.2);
    opacity: 0;
    transition: all .18s cubic-bezier(.2, .9, .3, 1);
}

.cb-square input:checked+.cb-box {
    transform: translateY(-2px);
    border-color: var(--accent);
}

.cb-square input:checked+.cb-box .dot {
    width: 12px;
    height: 12px;
    opacity: 1;
    transform: scale(1);
}

/* keyboard focus */
.cb-square input:focus+.cb-box {
    box-shadow: 0 0 0 4px rgba(239, 68, 68, 0.12);
}
</style>
